"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RIGHT_ARROW = exports.LEFT_ARROW = void 0;
exports.getCurrentlyFocusedIndex = getCurrentlyFocusedIndex;
exports.getNewIndexAfterDeletion = getNewIndexAfterDeletion;
exports.getNextIndex = getNextIndex;
exports.getNodeFromIndex = getNodeFromIndex;
var LEFT_ARROW = exports.LEFT_ARROW = 'ArrowLeft';
var RIGHT_ARROW = exports.RIGHT_ARROW = 'ArrowRight';
function getCurrentlyFocusedIndex(chipItems) {
  var _document$activeEleme;
  var focusedElementValue = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.getAttribute('data-encore-chip-id');
  return Array.from(chipItems === null || chipItems === void 0 ? void 0 : chipItems.keys()).findIndex(function (key) {
    return key === focusedElementValue;
  });
}
function getNextIndex(e, currentlyActiveIndex, chipItemsSize) {
  var nextActiveChipItemIndex = 0;
  switch (e.key) {
    case LEFT_ARROW:
      nextActiveChipItemIndex = currentlyActiveIndex - 1 < 0 ? chipItemsSize - 1 : currentlyActiveIndex - 1;
      return nextActiveChipItemIndex;
    case RIGHT_ARROW:
      nextActiveChipItemIndex = currentlyActiveIndex + 1 >= chipItemsSize ? 0 : currentlyActiveIndex + 1;
      return nextActiveChipItemIndex;
    default:
      return nextActiveChipItemIndex;
  }
}
function getNodeFromIndex(chipItems, index) {
  var value = Array.from(chipItems.keys())[index];
  return chipItems.get(value);
}
function getNewIndexAfterDeletion(chipItems, deletedElementIndex) {
  if (deletedElementIndex === -1) return -1;
  var previousIndex = deletedElementIndex - 1;
  if (previousIndex > -1) return previousIndex;
  var nextIndex = deletedElementIndex + 1;
  if (nextIndex < chipItems.size) return nextIndex;
  return -1;
}